import React from 'react';

export default function Absensi() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Absensi</h1>
      <p className="text-gray-500">Halaman Absensi</p>
    </div>
  );
}
